module.exports = __webpack_public_path__ + "static/media/chongzhijiaofeiguanlixitong.fb6d6bac.png";